import { apiUri } from '@/constants/Constants';
import { DealsDashboardClient } from '@/shared/api';

import type { RenewableDeal } from './renewal.types';

type GetRenewableDealResponse = { message: string; status_code: number; data: RenewableDeal };

/**
 * GET /v1/landlord/deals/renewable/{dealId} — the renewal flow's single source: per-RO intent,
 * grouping, snapshot, resolved address, and renter name/email. `source` is passed raw
 * (monolith/atlas/msa) — the endpoint normalizes it.
 */
export const getRenewableDeal = async (dealId: string, source: string): Promise<RenewableDeal> => {
  const { data } = await DealsDashboardClient.get<GetRenewableDealResponse>(
    apiUri.getRenewableDeal.replace('{dealId}', dealId),
    { params: { source } },
  );
  return data.data;
};
